"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailAdventureActionHandler = exports.FailAdventureActionArgs = void 0;
const Registries_1 = require("../../state/Registries");
const ActionType_1 = require("../ActionType");
class FailAdventureActionArgs {
    constructor() {
        this.__type = ActionType_1.ActionType.FailAdventure;
        this.__typeName = "FailAdventure";
    }
}
exports.FailAdventureActionArgs = FailAdventureActionArgs;
let FailAdventureActionHandler = class FailAdventureActionHandler {
    activate(sequence, container, action) {
        if (container.adventure.state !== "Active") {
            return;
        }
        container.failAdventure(sequence);
    }
};
FailAdventureActionHandler = __decorate([
    Registries_1.Actions.register(ActionType_1.ActionType.FailAdventure)
], FailAdventureActionHandler);
exports.FailAdventureActionHandler = FailAdventureActionHandler;
